import { Popover as BasePopover } from '@base-ui/react/popover'
import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const Popover = BasePopover.Root
export const PopoverTrigger = BasePopover.Trigger

export const PopoverContent = ({
  align,
  className,
  children,
}: {
  align?: 'center' | 'end' | 'start'
  className?: string
  children: ReactNode
}) => {
  return (
    <BasePopover.Portal>
      <BasePopover.Positioner sideOffset={4} align={align}>
        <BasePopover.Popup
          className={cn('origin-[var(--transform-origin)] rounded-md border bg-white p-3 shadow-lg', className)}
        >
          {children}
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </BasePopover.Portal>
  )
}
